import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "4px",
        backgroundColor: "#494949",
        boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
        height: "46px",
        // minWidth: '321px',
        color: "#fff",
        padding: "18px",
        gap: "70px",
        letterSpacing: 0,
    },
    leftSide: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",
    },
    rightSide: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
    },
    icon_container: {
        marginTop: "2px",
    },
    onActionText: {
        cursor: "pointer",
        textDecoration: "underline",
    },
}));

export default useStyles;
